export const widgetConstants = [
  null,
  {
    title: "سود و زیان",
    imagePath: "/assets/images/widgets/labeled_barchart.png",
    apiPath: "/dashboard/profitAndLoss",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 4,
      xl: 4,
    },
  },
  {
    title: "حساب ها",
    imagePath: "/assets/images/widgets/cheque.png",
    apiPath: "/dashboard/banking",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 4,
      xl: 4,
    },
  },
  null,
  null,
  {
    title: "فاکتور ها",
    imagePath: "/assets/images/widgets/invoices.png",
    apiPath: "/dashboard/salesFactor",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 4,
      xl: 4,
    },
  },
  null,
  null,
  {
    title: "آخرین اسناد",
    imagePath: "/assets/images/widgets/cheque.png",
    apiPath: "/dashboard/salesChart",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 4,
      xl: 4,
    },
  },
  {
    title: "بیشترین فروش",
    imagePath: "/assets/images/widgets/pie_chart.png",
    apiPath: "/dashboard/topSales",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 4,
      xl: 4,
    },
  },
  {
    title: "بیشترین خرید",
    imagePath: "/assets/images/widgets/pie_chart.png",
    apiPath: "/dashboard/topBuys",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 4,
      xl: 4,
    },
  },
  {
    title: "نمودار فروش",
    imagePath: "/assets/images/widgets/linear_chart.png",
    apiPath: "/dashboard/salesChart",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
  {
    title: "نمودار خرید",
    imagePath: "/assets/images/widgets/linear_chart.png",
    apiPath: "/dashboard/buysChart",
    col: {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 6,
      xl: 6,
    },
  },
];
